module.exports = __webpack_public_path__ + "static/media/TESTgcp2-removebg-preview.6787aaa8.png";